import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../css/Shared/SideNav.css';
import profile from '../../Assets/ProfileManagement/Assets-Desktop/user-profile.svg';
import arrow from '../../Assets/Announcement/images/Page-4.svg';
import premium from '../../Assets/ContainerStatus/Assets_Mobile/premium-icon.svg';
import customerSupport from '../../Assets/CustomerSupport/Assets-WebApp/customerSupport.svg';
import expand from '../../Assets/CustomerSupport/Assets_Mobile/expand.svg';
import condense from '../../Assets/CustomerSupport/Assets_Mobile/condense.svg';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AcceptTermsConditionsModal from '../Shared/AcceptTermsConditionsModal';
import TermsConditionModal from '../Shared/TermsConditionModal';
import { connect } from 'react-redux';
import {AES, enc}from 'crypto-js';
import Cookies from 'cookies-js';
import {  baseURL, utilityBaseURL } from '../../Services/config/apiGateway';
import { TERMS_AND_CONDITIONS_ENDPOINT, DOCUMENT_ENDPOINT } from '../../Services/config/apiEndPoints';
import { ApiCall } from '../../Services/utils/ApiCall';
import {successLoader,} from '../../Redux/_actions/loader.action';
import store from '../../Redux/_helpers/store';
import Logout from '../../Services/utils/Logout';
import { release } from '../../Services/utils/appMode';

class SideNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdown: false,
            hasOpentermsCondition: false,
            showDrawer: true,
            hasOpenterms: false,
            pdfURL : utilityBaseURL + DOCUMENT_ENDPOINT + "?documentPath="
        }
    }
    handleLogout = () =>{
        Logout();

    }
    toggleDropdown = () => {
        this.setState({ dropdown: !this.state.dropdown });
    }
    handleTermsConditions = () => {
        ApiCall(
            'GET',
            baseURL + TERMS_AND_CONDITIONS_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
             console.log("I am 500")
                }
                else{
                console.log('I am 200!');
                console.log("terms and conditions",apiData);
                const testAccess = Cookies.get('_msAL');
                //start
                this.props.dispatch(successLoader(false));
                var oReq = new XMLHttpRequest();
                var URLToPDF = this.state.pdfURL + apiData[0].termsFile;
              oReq.open("GET", URLToPDF, true);
              oReq.setRequestHeader("Authorization",'Bearer'+` ${testAccess}`);
             oReq.responseType = "blob";
             function pdfLoadCallback() {
                //end
                 store.dispatch(successLoader(true));
              }
              oReq.onload = function() {
                  // Once the file is downloaded, open a new window with the PDF
                  // Remember to allow the POP-UPS in your browser
                  const file = new Blob([oReq.response], { type: 'application/pdf' });
                  const fileURL = URL.createObjectURL(file);
                  pdfLoadCallback();
                  //end
                  window.open(fileURL, "_blank");
              };
              oReq.send();
            } 
            } 
        });
    }
    onCloseTermsConditionModal = () => {
        this.setState({ hasOpentermsCondition: false });
        this.setState({ showDrawer: true });
    };
    onYesModal = () => {
        this.setState({ hasOpentermsCondition: false });
        this.setState({ showDrawer: true });
    };
    showTermsAndCondition = () => {
        this.setState({ hasOpentermsCondition: false });
        this.setState({ hasOpenterms: true });
    }
    onClosetermsModal = () => {
        this.setState({ hasOpenterms: false });
        this.setState({ showDrawer: true });
    };
    render() {
        return (
            <>
                {this.state.showDrawer &&
                    <div className="wholeSidenav">
                        <div className="outerSidenav">
                            <div className="sidenavHeader">
                            <Link to={'/helloUser'} >
                                <div className="headerInner" >
                                    <img alt="profile" src={profile} width='55' height='55' />
                                    <p className="personNameText">{this.props.userProfileDataR?.firstName} {this.props.userProfileDataR?.lastName}</p>
                                </div>
                                </Link>
                            </div>
                            {release === '2' &&
                            <NavLink exact to="/ManageSubscription" className="active" activeClassName="main-active">
                                <div id="sidenavSection" class="hov">
                                    <div id="homeTexttext" class="crd">
                                        <img class="mr-3 pb-2" alt="profile" src={premium} width='31' height='31' />
                                        <img class="mr-3 pb-2" id="img-top" alt="profile" src={premium} width='31' height='31' />
                                        <small id="snntitle">Premium</small>
                                    </div>
                                    <img class="mt-2" alt="profile" src={arrow} width='10' height='11' />
                                </div>
                            </NavLink>
    }
                            <div className="active" activeClassName="main-active">
                                <div id="sidenavSection" class="hov" onClick={this.toggleDropdown}>
                                    <div id="homeTexttext" class="crd">
                                        <img class="mr-3 pb-2" alt="profile" src={customerSupport} width='31' height='31' />
                                        <img class="mr-3 pb-2" id="img-top" alt="profile" src={customerSupport} width='31' height='31' />
                                        <small id="snntitle">Customer Service</small>
                                    </div>
                                    <img class="mt-2" alt="profile" src={this.state.dropdown ? condense : expand} width='10' height='11' />
                                </div>
                            </div>
                            {this.state.dropdown &&
                                <div>
                                    <NavLink exact to="/FAQ" className="active" activeClassName="main-active">
                                        <div id="sidenavSectionoption" class="hov">
                                            <div id="homeTexttextoption" class="crd">
                                                <small id="snntitle">FAQ</small>
                                            </div>
                                            <img class="mt-2" alt="profile" src={arrow} width='10' height='11' />
                                        </div>
                                    </NavLink>
                                    <NavLink exact to="/RaiseQuery" className="active" activeClassName="main-active">
                                        <div id="sidenavSectionoption" class="hov">
                                            <div id="homeTexttextoption" class="crd">
                                                <small id="snntitle">Raise Query</small>
                                            </div>
                                            <img class="mt-2" alt="profile" src={arrow} width='10' height='11' />
                                        </div>
                                    </NavLink>
                                    <NavLink exact to="/ContactUs" className="active" activeClassName="main-active">
                                        <div id="sidenavSectionoption" class="hov">
                                            <div id="homeTexttextoption" class="crd">
                                                <small id="snntitle">Contact Us</small>
                                            </div>
                                            <img class="mt-2" alt="profile" src={arrow} width='10' height='11' />
                                        </div>
                                    </NavLink>
                                </div>
                            }
                            <div id="sidenavFooter" class="fixed-bottom">
                                <div class="sidenavtermsdivout" onClick={this.handleTermsConditions}>
                                    <small class="sidenavtermsdivsm">Terms and Conditions</small>
                                </div>
                                <Link to="" onClick={this.handleLogout} ><p className="logoutText">Logout</p></Link>
                            </div>
                        </div>
                        <div className="notSidenav" onClick={this.props.onClick}></div>
                    </div>
                }
                <AcceptTermsConditionsModal hasOpen={this.state.hasOpentermsCondition} onCloseModal={this.onCloseTermsConditionModal} onYesModal={this.onYesModal}>
                    <div>
                        <div class="AccepttermscondiDivout">
                            <small class="AccepttermscondiDivsm">Terms & Conditions Updated</small>
                            <small class="AccepttermscondiDivsmb"> Last Updated 19-Feb-2021</small>
                            <div class="AccepttermscondiDivin">
                                <small class="AccepttermscondiDivinsm">Please read and accept the new</small>
                                <small class="AccepttermscondiDivinsmb" onClick={this.showTermsAndCondition}>
                                    <small class="AccepttermscondiDivinsmtc">Terms & Conditions </small>
                                to proceed.
                                </small>
                            </div>
                        </div>
                    </div>
                </AcceptTermsConditionsModal>
                {this.state.hasOpenterms ? <TermsConditionModal onClick={this.onClosetermsModal} /> : null}
            </>
        );
    }
}
function mapStateToProps(state) {
    if(state.userProfileInfoReducer.data){
    return { 
//    userProfileDataR: state.userProfileInfoReducer.data,
userProfileDataR:JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
 }
}
  }
export default connect(mapStateToProps)(SideNav);
